<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalAttachVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          span {{ $t("products.tech_sheet") }}
          input(type="file", ref="tech_sheet", v-on:change="handleTechUpload()", accept="*")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          span {{ $t("products.security_sheet") }}
          input(type="file", ref="security_sheet", v-on:change="handleSegurityUpload()", accept="*")
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Products')

export default {
  name: 'ModalAttachmentspro',
  props: {
    form: {
      default: () => [],
      type: Object
    }
  },
  data: () => ({
    tech_sheet: '',
    security_sheet: ''
  }),
  validations: {
    form: {
      tech_file: {
        required: requiredIf(function () { return this.fileValidate })
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalAttachVisible',
      'productsCatalog'
    ]),
    getTitle () {
      return this.$t('products.edit')
    },
    fileValidate () {
      return this.tech_sheet.length > 0 || this.security_sheet.length > 0
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addAttachments',
      'setModalAttachVisible',
      'loadCatalog'
    ]),
    handleTechUpload () {
      this.tech_sheet = this.$refs.tech_sheet.files[0]
    },
    handleSegurityUpload () {
      this.security_sheet = this.$refs.security_sheet.files[0]
    },
    saveRecord () {
      this.addAttachments({
        form: this.form,
        tech_sheet: this.tech_sheet,
        security_sheet: this.security_sheet
      })
    },
    async getCatalog () {
      Object.keys(this.productsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    close () {
      this.setModalAttachVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
</style>
